import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { usePricing } from '../../contexts/PricingContext';
import { useDocPaging } from '../../contexts/DocPagingContext';
import { BriefPage } from './BriefPage';
import { BriefHeader } from './BriefHeader';
import { SystemSwimlane } from './SystemSwimlane';
import { briefHeadline, briefOrigin, briefProblems, briefSalesSchool, briefStepsTagline, briefSystem, briefSystemWithRecruiter, briefTrackRecord } from '../../data/partnershipBrief';
const label = 'text-[12px] font-bold uppercase tracking-[0.14em] text-[#4a5560]';
export function BriefPageOne() {
  const {
    hasRecruiter
  } = usePricing();
  const paging = useDocPaging();
  // With a corporate recruiter, HIRE runs the interviews too.
  const stages = hasRecruiter ? briefSystemWithRecruiter : briefSystem;
  return <BriefPage data-id="element-665" data-mp="3ieobr76183pc">
      <BriefHeader label="Partnership brief" data-id="element-666" data-mp="3ieeuc7z1z4v9" />

      <h1 className="brief-display mt-6 text-[44px] font-extrabold leading-[1.04] tracking-[-0.02em] max-w-[680px]" data-id="element-667" data-mp="3ed30trd25zhs">
        {briefHeadline.title}
      </h1>
      <p className="mt-3 text-[17px] leading-[1.5] text-[#2c3640] max-w-[700px]" data-id="element-668" data-mp="2wqztllfsfnvb">
        {briefHeadline.lead}
      </p>

      <h2 className={`mt-6 ${label}`} data-id="element-669" data-mp="2noi510cnuj55">The problem</h2>
      <div className="mt-3 grid grid-cols-3 gap-5" data-id="element-670" data-mp="2nptad4lr7yyd">
        {briefProblems.map(problem => <div key={problem.title} className="border-t border-[#d5dade] pt-3" data-id="element-671" data-mp="2rqc26ynnd50k">
            <div className="text-[16px] font-bold" data-id="element-672" data-mp="3fgfvod74fodu">{problem.title}</div>
            <p className="mt-0.5 text-[14.5px] leading-[1.5] text-[#2c3640]" data-id="element-673" data-mp="3ke7wxxtnomup">
              {problem.body}
            </p>
          </div>)}
      </div>

      <h2 className={`mt-5 ${label}`} data-id="element-674" data-mp="36muigyaluf6j">How it works</h2>
      <div className="mt-3" data-id="element-675" data-mp="3anwfd8h1uf5c">
        <SystemSwimlane stages={stages} data-id="element-676" data-mp="3an4xt1kaehy2" />
      </div>
      <p className="mt-3.5 text-[15px] font-bold" data-id="element-677" data-mp="294ktt59vaks">{briefStepsTagline}</p>

      <div className="mt-3 border-t-2 border-[#141a1f] pt-3 pb-2.5 grid grid-cols-4 gap-5 border-b border-b-[#d5dade]" data-id="element-678" data-mp="271mmltyub4z">
        {briefTrackRecord.map(stat => <div key={stat.label} data-id="element-679" data-mp="gv1p4l9u9s1f">
            <div className="brief-display text-[36px] font-extrabold leading-none text-[#14684d]" data-id="element-680" data-mp="gt8rtwl48k63">
              {stat.value}
            </div>
            <div className="mt-1.5 text-[14px] text-[#2c3640]" data-id="element-681" data-mp="7tu3p3sf8lor">
              {stat.label}
            </div>
          </div>)}
      </div>

      <div className="mt-4 grid grid-cols-2 gap-7" data-id="element-682" data-mp="2xwmkv9c3bax">
        <div data-id="element-683" data-mp="3u353r3ffv9vu">
          <h2 className="brief-display text-[19px] font-bold" data-id="element-684" data-mp="3u2wq39bhs0jl">
            {briefOrigin.title}
          </h2>
          <p className="mt-1.5 text-[14.5px] leading-[1.55] text-[#2c3640]" data-id="element-685" data-mp="3p9tr2lny3yw0">
            {briefOrigin.body}
          </p>
        </div>
        <div data-id="element-686" data-mp="3gaoxzuv5kxr8">
          <div className={label} data-id="element-687" data-mp="3gb8fjagw5k4q">{briefOrigin.proofLabel}</div>
          <dl className="mt-1" data-id="element-688" data-mp="3g8lxui0ado8s">
            {briefOrigin.proof.map((item, index) => <div key={item.label} className={`flex items-baseline gap-4 py-1.5 ${index > 0 ? 'border-t border-[#d5dade]' : ''}`} data-id="element-689" data-mp="3bau3zig2zs1y" data-mpi={index}>
                <dt className="brief-display w-[118px] shrink-0 text-[25px] font-extrabold" data-id="element-690" data-mp="2w7sqmxeqi5de">
                  {item.value}
                </dt>
                <dd className="text-[14.5px] text-[#2c3640]" data-id="element-691" data-mp="366s18lj28b31">{item.label}</dd>
              </div>)}
          </dl>
        </div>
      </div>

      <section className="mt-4 rounded-xl bg-[#121a20] px-6 py-5 flex gap-6" data-id="element-692" data-mp="3b4jsddbvrt66">
        <div className="flex-1 min-w-0" data-id="element-693" data-mp="2divv6q7lp6tl">
          <div className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#6fd6b0]" data-id="element-694" data-mp="2djxgrom8tbpk">
            {briefSalesSchool.eyebrow}
          </div>
          <h2 className="brief-display mt-2 text-[27px] font-extrabold leading-[1.15] text-white" data-id="element-695" data-mp="2nfqq6z4o0p34">
            {briefSalesSchool.title}
          </h2>
          <p className="mt-2.5 text-[14.5px] leading-[1.55] text-[#d7dde2]" data-id="element-696" data-mp="2s8bjlzjnt064">
            {briefSalesSchool.body}
          </p>
          <div className="mt-3 flex gap-6" data-id="element-697" data-mp="1zqpp5wy5wg7v">
            {briefSalesSchool.stats.map(stat => <div key={stat.label} className="border-l-2 border-[#6fd6b0] pl-3" data-id="element-698" data-mp="5ahacvsh9r3j">
                <div className="brief-display text-[21px] font-extrabold text-white leading-tight" data-id="element-699" data-mp="58ei053urlvn">
                  {stat.value}
                </div>
                <div className="text-[13.5px] text-[#aab4bc]" data-id="element-700" data-mp="f1c7iv79ib3r">{stat.label}</div>
              </div>)}
          </div>
        </div>
        <div className="w-[150px] shrink-0 flex flex-col items-center justify-center" data-id="element-701" data-mp="a7hgt7t8ovv6">
          <a href={briefSalesSchool.url} target="_blank" rel="noopener noreferrer" className="flex flex-col items-center" data-id="element-702" data-mp="nz5rd6nubca1">
            {/* White tile gives the code the quiet zone scanners need on a
                dark panel. Vector, so it prints sharp. */}
            <span className="block rounded-lg bg-white p-2.5" data-id="element-703" data-mp="sy8x6tbn9mj2">
              <QRCodeSVG value={briefSalesSchool.url} size={102} level="M" marginSize={0} fgColor="#141a1f" bgColor="#ffffff" title={`QR code: ${briefSalesSchool.url}`} data-id="element-704" data-mp="2zrb468iuwxr2" />
            </span>
            <span className="mt-2 text-center text-[13px] font-semibold leading-snug text-white" data-id="element-705" data-mp="1f7pdq64pjhti">
              {briefSalesSchool.qrCaption}
            </span>
          </a>
          {/* A real link, so it stays clickable in a PDF saved from the browser. */}
          <a href={briefSalesSchool.url} target="_blank" rel="noopener noreferrer" className="mt-1 text-center text-[13px] font-bold text-[#6fd6b0] underline underline-offset-2 whitespace-nowrap" data-id="element-706" data-mp="rimyt61gk32p">
            {briefSalesSchool.linkLabel}
          </a>
        </div>
      </section>

      <footer className="mt-auto flex items-center justify-between text-[13px]" data-id="element-707" data-mp="mk1xt4edtfd7">
        <span className="text-[#2c3640]" data-id="element-708" data-mp="2c01b8xp19qyn">D2D HIRE · {paging.label(1)}</span>
        <span className="font-bold" data-id="element-709" data-mp="2gy2yluthscfx">
          Pricing, guarantees and timeline on page {paging.page(2)} →
        </span>
      </footer>
    </BriefPage>;
}